import Card from '@/components/Card'
import * as React from 'react'
import { useForcedViewTheme } from '../theme'
import { PublicViewFieldsFragment } from '@/graphql/generated/graphql'

type TableProps = {
  publicViewFields: PublicViewFieldsFragment
}

export default function Table(props: TableProps) {
  const theme = useForcedViewTheme()
  const docFound = props.publicViewFields

  if (!docFound) return null

  // ID; Diplomado; CPF; Curso; Código EMEC; Tipo; Importado em;
  const rows = props.publicViewFields.dataKeyValues

  return (
    <div className="px-4 lg:px-0 max-w-6xl mx-auto ">
      <Card className="my-4 p-4 flex flex-col gap-2">
        <p className="font-semibold text-lg border-b border-gray-200 pb-2 mb-2">
          Dados do documento
        </p>
        {rows.map((row) => {
          return (
            <div className="grid grid-cols-2 gap-2 items-center" key={row.key}>
              <p
                style={{ color: theme.publicViewPrimaryColor }}
                className="text-sm"
              >
                {row.key}
              </p>
              <p>{row.value}</p>
            </div>
          )
        })}
      </Card>
    </div>
  )
}
